import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

/**
 * AdminRoute — protects /admin/* routes.
 * Must be authenticated AND have user_type === 'admin'.
 * Non-admins are redirected to /internship/projects.
 */
const AdminRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (user?.user_type !== 'admin') {
    return <Navigate to="/internship/projects" replace />;
  }

  return children;
};

export default AdminRoute;
